import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  ActionIcon,
  rem,
  Text,
  Flex,
  Tooltip,
  Button,
} from "@mantine/core";
import useStyles from "./style";
import { TbClockHour2 } from "react-icons/tb";
import { TimeInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import { useStopwatch } from "react-timer-hook";
import ClockModal from "../ClockModal/ClockModal.jsx";
import {
  breakEnd,
  breakStart,
  getUserLatestTracking,
  getUserTracking,
  tracking_clockin,
  tracking_clockout,
} from "../../services/UserTracking.js";
import { getDeviceLocation, getDeviceType } from "../../utils/geolocation.js";
import CustomTimer from "./custom-timer";
import { useDisclosure } from "@mantine/hooks";
import { IoMdStopwatch } from "react-icons/io";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import swal from "sweetalert";

import { showError } from "../../utils/index.js";
// import { BiStopwatch } from "react-icons/bi";

const DashboardTimer = ({
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  userTracking,
  setUserTracking,
  setShowInfo,
  setShowClockIn,
}) => {
  // const [opened_checkin_type, { close: close_checkin, open: open_checkin }] =
  //   useDisclosure(false);
  const [active, setActive] = useState(
    localStorage.getItem("clock-status") || "active"
  );

  const { profile } = useSelector((state) => state?.profile);
  const [isBreak, setIsBreak] = useState(false);
  const [isEnable, setIsEnable] = useState(false);
  const [loading, setIsLoading] = useState(false);

  const [selectedFacility, setSelectedFacility] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [currentTime, setCurrentTime] = useState(new Date());

  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [forceStop, setForceStop] = useState(false);
  const [clockInSeconds, setClockedInSeconds] = useState(0);

  // const [hoursWorked, setHoursWorked] = useState(0); // For total worked hours
  const [totalBreakTime, setTotalBreakTime] = useState(0);
  // const [checkoutTime, setCheckoutTime] = useState(endTime);
  const [selectedService, setSelectedService] = useState(null);
  const [evvLocationData, setEvvLocationData] = useState(null);
  React.useEffect(() => {
    if (clockInSeconds > 0 && !forceStop) {
      setIsTimerRunning(true);
    }
  }, [clockInSeconds]);

  const { classes } = useStyles();

  const startTimeRef = useRef(null);
  const endTimeRef = useRef(null);

  const startTimeIcon = (
    <ActionIcon
      variant="subtle"
      color="gray"
      onClick={() => startTimeRef.current?.showPicker()}
    >
      <IoMdStopwatch
        color="#000"
        style={{ width: rem(16), height: rem(16) }}
        stroke={1.5}
      />
    </ActionIcon>
  );

  const endTimeIcon = (
    <ActionIcon
      variant="subtle"
      color="gray"
      onClick={() => endTimeRef.current?.showPicker()}
    >
      <IoMdStopwatch
        color="#000"
        style={{ width: rem(16), height: rem(16) }}
        stroke={1.5}
      />
    </ActionIcon>
  );

  const icon = (
    <IconCalendar
      style={{ width: rem(18), height: rem(18), color: "#000000" }}
      stroke={1.5}
    />
  );

  // const workTimer = useStopwatch({ autoStart: false });
  const breakTimer = useStopwatch({ autoStart: false });

  const handleStartBreak = () => {
    console.log("🚀 ~ handleStartBreak", )
    setIsBreak(true);
    setIsTimerRunning(false);
    breakTimer.start();
  };

  const break_Start = async (status) =>{
     let _date = new Date(startDate);
    _date.setHours(0, 0, 0, 0);

    const payload = {
      tracker_id: userTracking?._id,
      clock_out: new Date(),
    };
    // }
    await breakStart(payload);
    const user_tracking = await getUserLatestTracking({ date: _date });
    setUserTracking(user_tracking);
    setClockedInSeconds(0)
  }

  const handleEndBreak = async () => {
    breakTimer.pause();
    setIsBreak(false);
    setIsTimerRunning(true);
      let _date = new Date(startDate);
    _date.setHours(0, 0, 0, 0);

    let _startTime = new Date(startDate);
    let splitted_start_time = startTime
      ? startTime?.split(":")
      : moment().format("hh:mm")?.split(":");
    _startTime.setHours(splitted_start_time[0], splitted_start_time[1], 0, 0);
    // _startTime = _startTime.toISOString()

    let _endTime = new Date(startDate);
    let splitted_end_time = endTime ? endTime?.split(":") : [];
    _endTime?.setHours(splitted_end_time[0], splitted_end_time[1], 0, 0);
    // _endTime = _endTime.toISOString()

    let payload = {
      facility: selectedFacility?.id,
      checkin_type: selectedFacility?.checkInType,
      date: _date,
      startTime: _startTime,
      endTime: _endTime,
      clock_in: new Date(),
      tracker_id: userTracking?._id,
      // inout: intervals.current,
    };
    if (selectedClient) {
      payload.client = selectedClient;
      payload.checkin_type = "client";
      payload.service = selectedService;
    }
    await breakEnd(payload);
  };

  const startTimer = () => {
    setIsTimerRunning(true);
    // setTotalBreakTime(userTracking?.total_break_time);
  };

  const stopTimer = () => {
    setIsTimerRunning(false);

    // setClockedInSeconds(0);
  };

  const stopTimerWithBreak = () => {
    setIsTimerRunning(false);
    // setClockedInSeconds(0);
  };

  const handleClockOut = async (status) => {
    let _date = new Date(startDate);
    _date.setHours(0, 0, 0, 0);

    const payload = {
      tracker_id: userTracking?._id,
      clock_out: new Date(),
      status: status,
    };

    // Get fresh location for clock-out EVV data (GPS on mobile, IP on desktop)
    payload.deviceType = getDeviceType();
    try {
      const loc = await getDeviceLocation();
      if (loc) {
        payload.evvLocation = {
          lat: loc.lat,
          lng: loc.lng,
          accuracy: loc.accuracy || null,
        };
        payload.locationSource = loc.source;
      }
    } catch (err) {
      // Location fetch failed — proceed without EVV data for clock-out
    }

    await tracking_clockout(payload);
    const user_tracking = await getUserLatestTracking({ date: _date });
    setUserTracking(user_tracking);
    setClockedInSeconds(0);
  };

  useEffect(() => {
    if (userTracking && userTracking.status === "clock-in") {
      setActive("inActive");
    } else {
      setActive("active");
    }
  }, [userTracking]);
  useEffect(() => {
    localStorage.setItem("clock-status", active);
  }, [active]);

  const handleSubmit = async () => {
    setIsLoading(true);
    let _date = new Date(startDate);
    _date.setHours(0, 0, 0, 0);

    let _startTime = new Date(startDate);
    let splitted_start_time = startTime
      ? startTime?.split(":")
      : moment().format("hh:mm")?.split(":");
    _startTime.setHours(splitted_start_time[0], splitted_start_time[1], 0, 0);

    let _endTime = new Date(startDate);
    let splitted_end_time = endTime ? endTime?.split(":") : [];
    _endTime?.setHours(splitted_end_time[0], splitted_end_time[1], 0, 0);

    let payload = {
      facility: selectedFacility?.id,
      checkin_type: selectedFacility?.checkInType,
      date: _date,
      startTime: _startTime,
      endTime: _endTime,
      clock_in: new Date(),
    };
    if (selectedClient) {
      payload.client = selectedClient;
      payload.checkin_type = "client";
      payload.service = selectedService;
    }

    // Include EVV location data and device info in payload
    if (evvLocationData) {
      payload.evvLocation = evvLocationData.evvLocation;
      payload.evvDistanceToSite = evvLocationData.evvDistanceToSite;
      payload.evvMatchedAddress = evvLocationData.evvMatchedAddress;
      payload.locationSource = evvLocationData.locationSource;
      if (evvLocationData.overrideAddress) {
        payload.overrideAddress = evvLocationData.overrideAddress;
      }
    }
    payload.deviceType = getDeviceType();

    try {
      await tracking_clockin(payload);

      const user_tracking = await getUserLatestTracking({ date: _date });

      setUserTracking(user_tracking);
      setEndTime(null);
      setShowInfo(true);
      // Reset EVV data so the next clock-in doesn't reuse stale address
      setEvvLocationData(null);
    } catch (error) {
      // EVV rejection errors are shown by tracking_clockin via showError
    } finally {
      setIsLoading(false);
    }
  };

  // React.useEffect(() => {
  //   console.log("🚀 ~ user_tracking ~ checkoutTime:", checkoutTime)
  // },[checkoutTime])

  // React.useEffect(async () => {
  //   let _date = new Date(startDate)
  //   _date.setHours(0, 0, 0, 0)

  //   const user_tracking = await getUserTracking({date: _date})

  //   setUserTracking(user_tracking)
  // },[])

  React.useEffect(() => {
    const fetchUserTracking = async () => {
      let _date = new Date(startDate);
      _date.setHours(0, 0, 0, 0);

      try {
        // const user_tracking = await getUserTracking({ date: _date });
        const user_tracking = await getUserLatestTracking({ date: _date });
        setUserTracking(user_tracking);
      } catch (error) {
        console.error("Error fetching user tracking:", error);
      }
    };

    fetchUserTracking();
  }, [startDate]);

  function getBreakTimes(inout) {
    const breakTimes = [];
    let durationInSeconds = 0;
    for (let i = 0; i < inout.length; i++) {
      const currentEnd = inout[i].end ? new Date(inout[i].end) : null;
      // const nextStart = new Date(inout[i + 1].start);
      const nextStart = inout[i + 1]
        ? new Date(inout[i + 1].start)
        : new Date();
      if (currentEnd && currentEnd < nextStart) {
        // breakTimes.push({
        //   breakStart: moment(currentEnd).format("hh:mm:ss A"),
        //   breakEnd: moment(nextStart).format("hh:mm:ss A"),
        //   durationInSeconds: (nextStart - currentEnd) / 1000,
        // });
        durationInSeconds += (nextStart - currentEnd) / 1000;
      }
    }
    return durationInSeconds;
    // return breakTimes;
  }

  React.useEffect(() => {
    if (userTracking) {
      if (userTracking?.client && userTracking?.status === "clock-in") {
        setSelectedClient(userTracking?.client);
        setSelectedService(userTracking?.service);
      }

      // Only show times for an active clock-in session (not a completed one)
      if (userTracking?.status === "clock-in") {
        let start_time = new Date(
          userTracking?.startTime || userTracking?.date?.start
        );
        let start_timer_hour = start_time?.getHours();
        start_timer_hour =
          String(start_timer_hour)?.length === 1
            ? `0${start_timer_hour}`
            : start_timer_hour;
        let start_timer_minutes = start_time?.getMinutes();
        start_timer_minutes =
          String(start_timer_minutes)?.length === 1
            ? `0${start_timer_minutes}`
            : start_timer_minutes;
        setStartTime(`${start_timer_hour}:${start_timer_minutes}`);
        setEndTime(null);
      } else {
        // No active session — clear start and end times
        setStartTime(null);
        setEndTime(null);
      }
      // setTotalBreakTime(userTracking?.total_break_time);
      setForceStop(false);
      // set timer data
      let latest_checkin_obj =
        userTracking?.inout[userTracking?.inout?.length - 1];

      // check if user is on break
      let boolean_var =
        latest_checkin_obj?.end && userTracking?.status === "clock-in"
          ? true
          : false;
      setIsBreak(boolean_var);

      // if(userTracking.status === "clock-in"){
      if (userTracking.status === "clock-in" && latest_checkin_obj?.end) {
        // let last_checkin_start_date = new Date(latest_checkin_obj?.start);
        let last_checkin_start_date = new Date(
          latest_checkin_obj?.start
        ).getTime();
        let last_checkin_end_date = new Date(latest_checkin_obj?.end).getTime();
        const now = new Date().getTime(); // Current date and time

        let diffInMs = last_checkin_end_date - last_checkin_start_date;
        // Convert milliseconds to hours and minutes
        let diffInSeconds = Math.floor(diffInMs / 1000); // Total seconds

        for (let i = 0; i < userTracking?.inout?.length - 1; i++) {
          let inoutItem = userTracking?.inout[i];
          let checkin_start_date = new Date(inoutItem?.start).getTime();
          let checkin_end_date = new Date(inoutItem?.end).getTime();
          let diff = checkin_end_date - checkin_start_date;
          let diffInSecs = Math.floor(diff / 1000); // Total seconds
          diffInSeconds += diffInSecs;
        }
        if (diffInSeconds > 0) {
          setClockedInSeconds(diffInSeconds);
        } else {
          setClockedInSeconds(0);
        }
        setTotalBreakTime(getBreakTimes(userTracking?.inout));
        setForceStop(true);
      } else if (!latest_checkin_obj?.end) {
        // let last_checkin_start_date = new Date(latest_checkin_obj?.start);
        let last_checkin_start_date = new Date(
          latest_checkin_obj?.start
        ).getTime();
        const now = new Date().getTime(); // Current date and time

        let diffInMs = now - last_checkin_start_date;
        // Convert milliseconds to hours and minutes
        let diffInSeconds = Math.floor(diffInMs / 1000); // Total seconds

        for (let i = 0; i < userTracking?.inout?.length - 1; i++) {
          // console.log('iii', userTracking?.inout[i])
          let inoutItem = userTracking?.inout[i];
          let checkin_start_date = new Date(inoutItem?.start).getTime();
          let checkin_end_date = new Date(inoutItem?.end).getTime();
          let diff = checkin_end_date - checkin_start_date;
          let diffInSecs = Math.floor(diff / 1000); // Total seconds
          diffInSeconds += diffInSecs;
        }
        setTotalBreakTime(getBreakTimes(userTracking?.inout));
        if (diffInSeconds > 0) {
          setClockedInSeconds(diffInSeconds);
        } else {
          setClockedInSeconds(0);
        }
      }
    }
  }, [userTracking]);


useEffect(() => {
  const interval = setInterval(() => {
    setCurrentTime(new Date());
  }, 1000); // updates every second
  return () => clearInterval(interval);
}, []);


  return (
    <>
      {/* <Box > */}
      <Grid className={classes.timerParent}>
        <Grid.Col p={0} sm={12} md={0.6} lg={0.6}>
          <button
            onClick={() => active !== "inActive" && setActive("active")}
            className={
              active == "active"
                ? // !isBreak
                  `${classes?.activeButton} ${classes.activeBgColor}`
                : classes?.activeButton
            }
          >
            <TbClockHour2 className={classes.iconSize} />
            <p className={classes.btnText}>
              {userTracking?.status !== "clock-in" ? "Clock In" : "Clock Out"}
            </p>
          </button>
          <Tooltip
            label="Clock in to activate break time"
            position={"right"}
            isMobileScreen={false}
            withArrow
            arrowOffset={2}
            arrowSize={6}
            offset={12}
            color="white"
            disabled={active == "active"}
            styles={{
              tooltip: {
                color: "#000000",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <button
              onClick={() => active !== "active" && setActive("inActive")}
              className={
                active == "inActive"
                  ? // isBreak
                    `${classes?.inActiveButton} ${classes.activeBgColor}`
                  : classes?.inActiveButton
              }
            >
              <TbClockHour2 className={classes.iconSize} />
              <p className={classes.btnText}>Break</p>
            </button>
          </Tooltip>
        </Grid.Col>
        <Grid.Col sm={12} md={9.4} lg={9.4} style={{ alignContent: "center" }}>
          <Grid justify="Space-between" className={classes.timerInputParent}>
            <Grid.Col md={2}>
              {/* <DatePickerInput
                icon={icon}
                label="Start Date"
                placeholder="Pick date"
                // defaultDate={new Date()}
                value={startDate}
                onChange={(value) => setStartDate(value)}
              /> */}
              <Box className={classes.dayTimeBox}>
                <Text className={classes.dayBox}>
                  {moment(currentTime).format("dddd, MMM D")}
                </Text>
                <Text className={classes.timeBox}>
                  {moment(currentTime).format("hh:mm a")}
                </Text>
              </Box>
            </Grid.Col>
            <Grid.Col md={10}>
              <Grid
                justify="Space-between"
                className={classes.timerInputParent}
              >
                <Grid.Col md={6}>
                  <TimeInput
                    label="Start Time"
                    ref={startTimeRef}
                    icon={startTimeIcon}
                    readOnly
                    onClick={() => startTimeRef.current?.showPicker()}
                    value={startTime || ""}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                </Grid.Col>
                <Grid.Col md={6}>
                  <TimeInput
                  key={endTime || 'empty'}
                    label="End Time"
                    readOnly
                    ref={endTimeRef}
                    icon={endTimeIcon}
                    onClick={() => endTimeRef.current?.showPicker()}
                    value={endTime || ""}
                    onChange={(e) => setEndTime(e.target.value)}
                  />
                </Grid.Col>

                <Box className={classes.clockInParent}>
                  {/* <button className={classes.clockInBtn} onClick={start}>
                Clock In
              </button> */}
                  {active === "active" ? (
                    <>
                      <ClockModal
                        isEnable={isEnable}
                        setIsEnable={setIsEnable}
                        // timerStart={workTimer?.isRunning}
                        timerStart={isTimerRunning}
                        startCSS={classes.clockInBtn}
                        btnName={"clock in"}
                        handleSubmit={handleSubmit}
                        setActive={setActive}
                        startTimer={startTimer}
                        // hardDisabled={userTracking?.inout[userTracking?.inout?.length - 1]?.end === null ? true : false}
                        hardDisabled={
                          userTracking?.status === "clock-in" ? true : false
                        }
                        selectedFacility={selectedFacility}
                        setSelectedFacility={setSelectedFacility}
                        selectedClient={selectedClient}
                        setSelectedClient={setSelectedClient}
                        startTime={startTime}
                        endTime={endTime}
                        loading={loading}
                        selectedService={selectedService}
                        setSelectedService={setSelectedService}
                        setEvvLocationData={setEvvLocationData}
                        // openCheckinType={open_checkin}
                      />
                      {/* <SelectCheckInType opened={opened_checkin_type} open={open_checkin} close={close_checkin} /> */}
                    </>
                  ) : isBreak ? (
                    <ClockModal
                      isEnable={isEnable}
                      setIsEnable={setIsEnable}
                      startTimer={() => handleEndBreak()}
                      startCSS={classes.clockInBtn}
                      btnName={"end break"}
                      handleSubmit={handleSubmit}
                      loading={loading}
                    />
                  ) : (
                    <ClockModal
                      isEnable={isEnable}
                      setIsEnable={setIsEnable}
                      startTimer={() => handleStartBreak()}
                      startCSS={classes.clockInBtn}
                      btnName={"start break"}
                      hardDisabled={
                        userTracking?.status === "clock-in" ? false : true
                      }
                      handleClockOut={handleClockOut}
                      stopTimer={stopTimer}
                      stopTimerWithBreak={stopTimerWithBreak}
                      break_Start={break_Start}
                    />
                  )}
                </Box>
              </Grid>
            </Grid.Col>
          </Grid>
        </Grid.Col>
        <Grid.Col sm={12} md={2} lg={2}>
          {profile?.user?.type !== "staff" && (
            <Flex align={"center"} justify="flex-end">
              <Button
                variant="white"
                radius={"md"}
                onClick={() => setShowClockIn(false)}
              >
                <RxCross2 size={20} color="#000" />
              </Button>
            </Flex>
          )}
          <Box className={classes.clockParent}>
            <h5 className={classes.hoursWorked}>Hours Worked</h5>
            {/* <ReactTimer
              className={classes.countTimer}
              seconds={workTimer.seconds}
              minutes={workTimer.minutes}
              hours={workTimer.hours}
              days={workTimer.days}
            /> */}

            <CustomTimer
              startTime={clockInSeconds}
              isTimerRunning={isTimerRunning}
            />

            {/* <button className={classes.clockOutBtn} onClick={pause}>
              Clock Out
            </button> */}
            <ClockModal
              isEnable={isEnable}
              setIsEnable={setIsEnable}
              // startTimer={workTimer.pause}
              startCSS={classes.clockOutBtn}
              btnName={"clock out"}
              handleSubmit={handleSubmit}
              handleClockOut={handleClockOut}
              stopTimer={stopTimer}
              userTracking={userTracking}
              setActive={setActive}
              // hardDisabled={userTracking?.inout[userTracking?.inout?.length - 1]?.end === null ? false : true}
              hardDisabled={
                isBreak
                  ? true
                  : userTracking?.status === "clock-in"
                  ? false
                  : true
              }
            />
            <Flex align={"center"} gap={10} justify={"center"}>
              {/* {active === "inActive" || isBreak ? ( */}
              {isBreak ? (
                <Text className={classes.breakTimer}>Break Time</Text>
              ) : (
                ""
              )}
              {/* {active === "inActive" || isBreak ? ( */}
              {isBreak ? (
                <CustomTimer
                  className={classes.breakTimer}
                  startTime={totalBreakTime}
                  isTimerRunning={
                    isTimerRunning ||
                    (!isTimerRunning && userTracking?.status !== "clock-in")
                      ? false
                      : true
                  }
                />
              ) : (
                ""
              )}
            </Flex>
          </Box>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default DashboardTimer;
